if (!customElements.get('product-bar')) {
  customElements.define('product-bar', class ProductBar extends HTMLElement {
    constructor() {
      super();
      this.visibleClass = 'show-bar';
      this.productBar = this.querySelector('.sticky-addtocart');
      this.productBarSelector = this.productBar.querySelector('select[name="id"]');
      this.productForm = this.querySelector('form');
      this.productMainForm = document.querySelector('.js-product-form');
    
      this.handle();
      document.addEventListener('scroll', this.handle.bind(this));
      if (this.productBarSelector) {
        this.productBarSelector.addEventListener('change', this.switchVariant.bind(this));
      }
  	}
  
    handle() {
      if (this.productMainForm !== null) {
        var rect = this.productMainForm.getBoundingClientRect();
        var contentOffset = rect.height + rect.top;

        if (contentOffset <= 0) {
          this.productBar.classList.add(this.visibleClass);
        } else {
          this.productBar.classList.remove(this.visibleClass);
        }
      }
    }
  
    switchVariant() {
      document.dispatchEvent(new Event('barSelectorChanged'));
    }
  
  });
}
